import Vue from "vue";
import { STATUS_CODES } from "@/utils/api/apiConstants";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
  timeout: 2000,
};

const initialNotify = { message: null, code: null };

const defaultNotifyData = {
  message: "Đã xảy ra lỗi không xác định. Vui lòng thử lại.",
  code: -1,
};

// CODE: 0 là thành công
// CODE: từ 21 => 40 là cảnh báo
// CODE: nhỏ hơn 20 là lỗi

export const actions = {
  async addNotify({ commit }, data = initialNotify) {
    console.info("Log add Notify:", data);

    const originalMessage =
      data?.data?.message ?? data?.message ?? defaultNotifyData.message;
    const codeValue = data?.code ?? defaultNotifyData.code;
    let toastType = "error"; // Mặc định
    let toastTitle = "Error"; // Tiêu đề mặc định
    let detailedMessage = originalMessage; // Nội dung mặc định

    if (STATUS_CODES.SUCCESS_VALUES.includes(codeValue)) {
      toastType = "success";
      toastTitle = "THÀNH CÔNG";
    } else if (STATUS_CODES.WARNING_VALUES.includes(codeValue)) {
      toastType = "warning";
      toastTitle = "CẢNH BÁO";
    } else {
      // error
      toastType = "error";
      toastTitle = "THẤT BẠI";
    }

    if (
      toastType === "warning" &&
      data?.code > 20 &&
      data?.code <= 40 &&
      Array.isArray(data?.detail) &&
      data?.detail?.length > 0
    ) {
      detailedMessage = data?.detail[0]?.message;
    } else if (detailedMessage === "Request failed with status code 404") {
      detailedMessage = "Không tìm thấy máy chủ hoặc tài nguyên.";
    }

    // console.log("LOG ADD NOTIFY : ", data);
    try {
      this._vm.$toast[toastType](detailedMessage, options);
    } catch (error) {
      console.error("Lỗi khi hiển thị thông báo:", error);
    }
    // switch (toastType) {
    //   case "success":
    //     Toast.success(detailedMessage, options);
    //     break;
    //   case "warning":
    //     Toast.warning(detailedMessage, options);
    //     break;
    //   case "error":
    //     Toast.error(detailedMessage, options);
    //     break;
    //   default:
    //     Toast.info(detailedMessage, options);
    //     break;
    // }

    // if (data.code === 0) {
    //   toast.success();
    //   Vue.$toast.success(data.message, options);
    // } else if (data.code === 23) {
    //   Vue.$toast.warning(data.message, options);
    // } else {
    //   Vue.$toast.error(data.message, options);
    // }
  },
};

// import Vue from "vue";
// import { STATUS_CODES } from "@/utils/api/apiConstants";
// import ToastMessage from "@/components/widgets/toastComponents.vue";

// const defaultNotifyData = {
//   message: "Đã xảy ra lỗi không xác định. Vui lòng thử lại.",
//   code: -1,
// };
// const commonToastOptions = {
//   timeout: 2000,
//   closeButton: true,
//   position: "top-right",
// };
// export const actions = {
//   async addNotify({ commit }, payload) {
//     const message = payload?.data?.message ?? payload?.message ?? "Lỗi không xác định";
//     const code = payload?.data?.code ?? -1;

//     let type = "error";
//     let title = "THẤT BẠI";

//     if (STATUS_CODES.SUCCESS_VALUES.includes(code)) {
//       type = "success";
//       title = "THÀNH CÔNG";
//     } else if (STATUS_CODES.WARNING_VALUES.includes(code)) {
//       type = "warning";
//       title = "CẢNH BÁO";
//     }

//     // Render component thay vì HTML string
//     Vue.$toast(
//       {
//         component: ToastMessage,
//         props: {
//           title,
//           message
//         }
//       },
//       {
//         type: type,
//         ...commonToastOptions
//       }
//     );
//   }
// };
